export default "__VITE_ASSET__1f75a12b__"